import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { IntroSection } from './components/IntroSection';
import { ProblemSection } from './components/ProblemSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { OutcomesSection } from './components/OutcomesSection';
import { CoursePreviewSection } from './components/CoursePreviewSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const script = document.createElement('script');
      script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','2032586933980278');fbq('track','PageView');`;
      document.head.appendChild(script);
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=2032586933980278&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  return <div className="min-h-screen bg-[#FAFAF8] text-[#1E2330]" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <IntroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <HowItWorksSection data-id="element-5" />
        <OutcomesSection data-id="element-6" />
        <CoursePreviewSection data-id="element-7" />
        <BonusesSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <ClosingSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <WhatsAppButton data-id="element-14" />
    </div>;
}